import { StepItem, STEPS, Steps } from '../../../'
import { Application } from '../../../../application/application'
import { isApplicationClosedStep } from './steps/application-closed'
import { isBackgroundCheckStep } from './steps/background-check'
import { isBackgroundCheckExternalLinkStep } from './steps/background-check-external-link'
import { isPlatformWorkflowStep } from './steps/platform-workflow'
import { isProfileStep } from './steps/profile-setup'
import { isProgressCheckStep } from './steps/progress-check'

export interface Options {
  isAtCapacity?: boolean
  isDxOnboardingPlatformWorkflowComplete?: boolean
}

export function determineCurrentStepAustralia(
  application: Application,
  options: Options
): StepItem {
  const profileStep = isProfileStep(application)
  const backgroundCheckStep = isBackgroundCheckStep(application, options)
  const applicationClosedStep = isApplicationClosedStep(application, options)
  const platformWorkflowStep = isPlatformWorkflowStep()
  const backgroundCheckExternalLinkStep = isBackgroundCheckExternalLinkStep(
    application,
    options
  )
  const progressCheckStep = isProgressCheckStep(application, options)

  if (profileStep) {
    return STEPS[Steps.ProfileSetup]
  }

  if (backgroundCheckStep) {
    return STEPS[Steps.BackgroundCheck]
  }

  if (applicationClosedStep) {
    return STEPS[Steps.ApplicationClosed]
  }

  if (platformWorkflowStep) {
    if (options.isDxOnboardingPlatformWorkflowComplete) {
      return STEPS[Steps.DropshippingConfirm]
    }
    return STEPS[Steps.StartOnBoardingWorkflow]
  }

  if (backgroundCheckExternalLinkStep) {
    return STEPS[Steps.BackgroundCheckExternalLink]
  }

  if (progressCheckStep) {
    return STEPS[Steps.DropshippingConfirm]
  }

  return null
}
